import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <style>{`
        /* Fade-in animation for the whole page */
        .legal-page {
          animation: fadeIn 0.6s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .legal-content {
          background: #fff;
          border-radius: 16px;
          padding: 2.5rem 2rem;
          box-shadow: 0 8px 30px rgba(0,0,0,0.04);
          margin: 2rem 0;
        }

        .legal-content h2 {
          font-size: 2rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1.5rem;
        }

        .legal-content h3 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #0a1a3d;
          margin: 2rem 0 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 2px solid #f0f0f0;
          transition: border-color 0.3s;
        }

        .legal-content h3:hover {
          border-color: #e86b24;
        }

        .legal-content p,
        .legal-content li {
          color: #444;
          line-height: 1.8;
          font-size: 1rem;
          margin-bottom: 1rem;
        }

        .legal-content ul {
          padding-left: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .legal-content a {
          color: #e86b24;
          text-decoration: none;
          transition: color 0.2s;
        }

        .legal-content a:hover {
          color: #d2551a;
          text-decoration: underline;
        }

        .legal-footer-note {
          text-align: center;
          margin-top: 2rem;
          font-size: 0.9rem;
          color: #888;
        }

        @media (max-width: 576px) {
          .legal-content {
            padding: 1.5rem 1.2rem;
          }
        }
      `}</style>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Privacy Policy</h1>
            <ul className="breadcumb-menu">
              <li><Link to="/">Home</Link></li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container legal-page">
        <div className="legal-content">
          <h2>Privacy Policy For Sagama Homes Website</h2>

          <h3>1. Who We Are</h3>
          <p>
            Sagama Homes Ltd, is a Real Estate Company. We are the data controller for information collected through this website.
            Contact: sagamahomes.com | 07055558942
          </p>

          <h3>2. Information We Collect</h3>
          <p>We collect information you provide directly to us:</p>
          <ul>
            <li><strong>Contact enquiries</strong> — your full name, email address, phone number, subject, and message when you use the contact form.</li>
            <li><strong>Event registrations</strong> — first name, last name, email, phone number, organisation, and professional role when you register for a free awareness event.</li>
            <li><strong>Training enrolment enquiries</strong> — name, email, phone, organisation, and role when you express interest in a training programme.</li>
            <li><strong>Template downloads</strong> — email address (optional) when you request a free compliance template.</li>
            <li><strong>Template purchases</strong> — email address and payment information (processed securely by Paystack; LawDigits does not store card details).</li>
            <li><strong>Resource uploads</strong> — name, email, organisation, resource file, and pricing information when you submit a resource for publication.</li>
          </ul>
          <p>
            We also collect limited technical data automatically: your IP address, browser type, and pages visited. This data is used solely for security and aggregated analytics.
          </p>

          <h3>3. Legal Bases for Processing</h3>
          <p>
            Under the Nigeria Data Protection Act 2023 (NDPA) and applicable data protection law, we process your personal data on the following lawful bases:
          </p>
          <ul>
            <li><strong>Consent</strong> — for newsletter communications and non-essential cookies (you may withdraw consent at any time).</li>
            <li><strong>Contract performance</strong> — to process template purchases, deliver downloads, and respond to training enquiries.</li>
            <li><strong>Legal obligation</strong> — to retain transaction records and comply with regulatory requirements.</li>
            <li><strong>Legitimate interests</strong> — to improve our website, prevent fraud, and maintain the security of our services, where this does not override your rights.</li>
          </ul>

          <h3>4. How We Use Your Information</h3>
          <ul>
            <li>Respond to your enquiries and provide the services you have requested.</li>
            <li>Send event confirmation and reminder emails.</li>
            <li>Deliver template download links and purchase confirmations.</li>
            <li>Contact you about training programmes you expressed interest in.</li>
            <li>Review and publish community-contributed resources (with your permission).</li>
            <li>Maintain records of transactions for accounting and compliance purposes.</li>
            <li>Improve our website and services through aggregated, anonymised analytics.</li>
          </ul>
          <p>
            We do not sell, rent, or trade your personal data to third parties for marketing purposes.
          </p>

          <h3>5. Cookies & Tracking</h3>
          <p>
            Our website uses cookies — small text files stored on your device. We use three categories:
          </p>
          <ul>
            <li><strong>Necessary cookies</strong> — required for the site to function (session management, security tokens). These are always active and cannot be disabled.</li>
            <li><strong>Functional cookies</strong> — store your preferences (such as your cookie consent choice) so you don't need to re-select them on each visit.</li>
            <li><strong>Analytics cookies</strong> — aggregated, anonymised data about how visitors navigate the site, used solely to improve our content and user experience.</li>
          </ul>
          <p>
            You can change your cookie preferences at any time using the button below, or by clicking Cookie Settings in the footer.
          </p>

          <h3>6. Third-Party Services</h3>
          <p>
            Email delivery — we use a transactional email service (configured via SMTP) to send confirmation emails. We share only the email address and name required to deliver the message.
          </p>

          <h3>7. Data Retention</h3>
          <p>We retain your personal data only for as long as necessary:</p>
          <ul>
            <li><strong>Contact and event enquiries</strong> — up to 2 years, or until you request deletion.</li>
            <li><strong>Transaction records (template purchases)</strong> — 2 years, as required by Nigerian tax and accounting law.</li>
            <li><strong>Training enquiries</strong> — 12 months from your last interaction.</li>
            <li><strong>Resource submissions</strong> — for the duration the resource remains published, plus 1 year.</li>
          </ul>

          <h3>8. Your Rights Under the NDPA 2023</h3>
          <p>As a data subject, you have the right to:</p>
          <ul>
            <li><strong>Access</strong> — request a copy of the personal data we hold about you.</li>
            <li><strong>Rectification</strong> — ask us to correct inaccurate or incomplete data.</li>
            <li><strong>Erasure</strong> — request deletion of your data where there is no lawful reason for us to continue processing it.</li>
            <li><strong>Data portability</strong> — receive your data in a structured, machine-readable format.</li>
            <li><strong>Object</strong> — object to processing based on legitimate interests.</li>
            <li><strong>Withdraw consent</strong> — where processing is based on consent, you may withdraw it at any time without affecting the lawfulness of prior processing.</li>
            <li><strong>Lodge a complaint</strong> — with the Nigeria Data Protection Commission (NDPC) at ndpc.gov.ng.</li>
          </ul>
          <p>
            To exercise any of these rights, email us at <a href="mailto:legal@sagamahomes.com">legal@sagamahomes.com</a> with the subject line "Data Subject Request". We will respond within 2 days.
          </p>

          <h3>9. Data Security</h3>
          <p>
            We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, loss, or disclosure, including encrypted storage, rate-limiting on our forms, and HMAC-signed download links.
          </p>

          <h3>10. International Transfers</h3>
          <p>
            Your data is primarily processed and stored within Nigeria. Where any data is transferred to a service provider in another jurisdiction, we ensure appropriate safeguards are in place consistent with the NDPA 2023, including standard contractual clauses or adequacy decisions where applicable.
          </p>

          <h3>11. Children's Privacy</h3>
          <p>
            Our services are not directed at persons under the age of 18. We do not knowingly collect personal data from minors. If you believe we have inadvertently collected such data, please contact us immediately and we will delete it.
          </p>

          <h3>12. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. We will post the updated policy on this page with a revised "Last updated" date. Continued use of the site after changes constitutes acceptance of the revised policy.
          </p>

          <h3>13. Contact & Complaints</h3>
          <p>
            For any privacy-related questions, requests, or concerns, please contact our Data Protection Officer:
          </p>
          <p>
            Email: <a href="mailto:legal@sagamahomes.com">legal@sagamahomes.com</a><br />
            Phone: 07055558942<br />
            Address: ConOil Filling Station Kado, Kado Estate
          </p>
          <p>
            If you are dissatisfied with our response, you have the right to lodge a complaint with the Nigeria Data Protection Commission (NDPC) at <a href="https://ndpc.gov.ng" target="_blank" rel="noopener noreferrer">ndpc.gov.ng</a>.
          </p>

          <div className="legal-footer-note">
            2026. All rights reserved.
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;